var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSettingactive = function SvgSettingactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#148DFD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#settingactive_svg__a)",
    fillRule: "evenodd",
    d: "M16.55 4.119a2.02 2.02 0 0 1 1.382 1.917v.055c0 1.099.878 1.997 1.977 2.02l.118.003a2.02 2.02 0 0 1 1.385 3.45l-.039.038a2.02 2.02 0 0 0-.03 2.826l.08.086a2.02 2.02 0 0 1-1.459 3.418h-.055a2.02 2.02 0 0 0-2.02 1.977l-.003.118a2.02 2.02 0 0 1-3.449 1.384l-.038-.038a2.02 2.02 0 0 0-2.827-.031l-.085.082a2.02 2.02 0 0 1-3.418-1.46v-.055a2.02 2.02 0 0 0-1.977-2.02l-.119-.003a2.02 2.02 0 0 1-1.384-3.45l.038-.038a2.02 2.02 0 0 0 .031-2.826l-.081-.086a2.02 2.02 0 0 1 1.46-3.418h.054a2.02 2.02 0 0 0 2.02-1.977l.003-.118a2.02 2.02 0 0 1 3.45-1.384l.038.038a2.02 2.02 0 0 0 2.827.031l.085-.082a2.02 2.02 0 0 1 2.037-.457",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 2.501
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "settingactive_svg__a",
    x1: 13,
    x2: 13,
    y1: 3.996,
    y2: 22.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6EDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6EDFF",
    stopOpacity: 0
  })))));
};
export { SvgSettingactive as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiNzkwOGFhYmZkYTY3OTViMGFkMWRhOWY3ZGM4N2UwODguc3ZnIjs=";